import { Icons } from "../icons";

export default function Footer() {
    return (
        <footer className="w-full border-t border-border/40 bg-background/50 backdrop-blur-sm mt-auto">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 py-6 px-4 md:py-8 text-sm text-muted-foreground">
                {/* Left: Name & Email */}
                <div className="flex flex-col items-center md:items-start gap-1">
                    <span className="font-semibold text-foreground">
                        Animikh Aich
                    </span>
                    <a
                        href="mailto:animikhaich@gmail.com"
                        className="hover:text-primary transition-colors"
                    >
                        animikhaich@gmail.com
                    </a>
                </div>

                {/* Center: Copyright */}
                <div className="text-center text-xs opacity-70">
                    <p>
                        © 2025 Animikh Aich. All rights reserved. Built with
                        React, VideoPrism and Qdrant.
                    </p>
                </div>

                {/* Right: Social Icons */}
                <div className="flex items-center gap-6">
                    <a
                        href="https://www.linkedin.com/in/animikh-aich/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-muted-foreground transition-colors hover:text-primary hover:scale-110 transform duration-200"
                        aria-label="LinkedIn"
                    >
                        <Icons.LinkedinIcon className="h-5 w-5" />
                    </a>
                    <a
                        href="https://x.com/animikh_aich"
                        target="_blank"
                        rel="noreferrer"
                        className="text-muted-foreground transition-colors hover:text-primary hover:scale-110 transform duration-200"
                        aria-label="Twitter"
                    >
                        <Icons.TwitterIcon className="h-5 w-5" />
                    </a>
                    <a
                        href="https://github.com/AnimikhAich"
                        target="_blank"
                        rel="noreferrer"
                        className="text-muted-foreground transition-colors hover:text-primary hover:scale-110 transform duration-200"
                        aria-label="GitHub"
                    >
                        <Icons.GithubIcon className="h-5 w-5" />
                    </a>
                </div>
            </div>
        </footer>
    );
}
